import { render, staticRenderFns } from "./browse-genres.vue?vue&type=template&id=d1e2c3cc&scoped=true&"
import script from "./browse-genres.vue?vue&type=script&lang=js&"
export * from "./browse-genres.vue?vue&type=script&lang=js&"
import style0 from "./browse-genres.vue?vue&type=style&index=0&id=d1e2c3cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1e2c3cc",
  null
  
)

export default component.exports